import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */ /*
    * Licensed Materials - Property of IBM
    *
    * PID 5725-H26
    *
    * Copyright IBM
    *
    * Copyright IBM Corporation 2020. All Rights Reserved.
    *
    * US Government Users Restricted Rights - Use, duplication or disclosure
    * restricted by GSA ADP Schedule Contract with IBM Corp.
    */
/* eslint-disable-next-line import/no-cycle */
import SSOAuthentication from './SSOAuthentication';

/** Component that will be used in order to login using SSO IDP Authentication */
var SSOIDPAuthentication = /*#__PURE__*/_createClass(function SSOIDPAuthentication() {
  _classCallCheck(this, SSOIDPAuthentication);
});
_defineProperty(SSOIDPAuthentication, "login", function (input) {
  SSOAuthentication.login(input, 'IDP');
});
/**
 * Logs the current user out.
 * This kills the server session associated with the current window, as well
 * as clearing the sessionStorage for the current window.
 *
 * @param {function} callback a function that will be invoked on completion.
 * The callback function will be passed a boolean indicating success and an
 * object representing the response.
 */
_defineProperty(SSOIDPAuthentication, "logout", function () {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var reportLogoutError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  SSOAuthentication.logout(callback, reportLogoutError);
});
export { SSOIDPAuthentication as default };